import  { useState } from "react";

import { useGoogleLogin } from "@react-oauth/google";
import { Spin } from "antd";
import { useRouter } from "next/router";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { ReactToastify } from "../../helper/ReusableComponents";
import { onLogout, updateStateOnGoogleSignin } from "../../store/actions";
import { AxiosInstance, EncryptObjectData, logout } from "../../utilities";

export default function GoogleLoginComponent(props) {
  const [spin, setSpin] = useState(false);
  const router = useRouter();
  const dispatch = useDispatch();

  // Google login hook with popup flow
  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    redirectUri: process.env.GOOGLE_REDIRECT_URI,
    use_fedcm_for_prompt: true,
    onSuccess: async (codeResponse) => {
      setSpin(true);
      try {
        const response = await AxiosInstance(4007, "application/json").post(
          "/auth/google/token",
          { code: codeResponse.code }
        );

        const responseData = response?.data;
        if (responseData?.status === 200) {
          const userData = responseData.userData;
          const token = responseData.token;
          
          // Store encrypted data
          localStorage.setItem(
            "data",
            EncryptObjectData({
              ...userData,
              role: userData?.role?.trim()?.toLowerCase()?.replaceAll(" ", "_")
            })
          );
          
          localStorage.setItem("token", EncryptObjectData(token));
          
          toast.success(<ReactToastify title="Success" desc={responseData.msg} />);
          
          dispatch(updateStateOnGoogleSignin(token, {
            ...userData,
            role: userData?.role?.trim()?.toLowerCase()?.replaceAll(" ", "_")
          }));

          if (router.asPath !== window.location.pathname) {
            router.push(window.location.pathname);
          }
        }
      } catch (error) {
        handleGoogleError(error);
      } finally {
        setSpin(false);
      }
    },
    onError: (error) => {
      if (error.error === "popup_closed_by_user") return;
      toast.error(<ReactToastify title="Error" desc="Login failed" />);
    }
  });

  const handleGoogleError = (error) => {
    const errorResponse = error?.response;
    if (errorResponse?.status === 403) {
      logout();
      dispatch(onLogout());
      router.push(window.location.pathname);
    } else {
      toast.error(
        <ReactToastify 
          title="Error" 
          desc={errorResponse?.data?.msg || "Authentication failed"}
        />
      );
    }
  };

  return (
    <>
      {spin ? <Spin style={{ height: "fit-content", width: "fit-content" }} spinning={spin} /> :
      <button 
        className="img_btn"
        onClick={() => googleLogin()}
        disabled={spin}
      >
        <img
          src="/assets/images/google_icon_modal.svg"
          alt="Google Sign-In"
          width={27}
          height={27}
        />
      </button>}
    </>
  );
}